export default {
  /**
   * 分为两种配置
   * 1、当前主题的摄像机参数
   * 2、当前地图的摄像机视野限制参数
   */

  default: {
    centerCoord: [17.93984230227, 27.12966105238],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 49.9,
    distance: 1900000,
    heading: 0,
    pitch: 86,
    duration: 1,
    fly: true
  },
  rank: {
    centerCoord: [17.89136777223, 33.26388217689],
    coordType: 0,
    coordTypeZ: 0,
    coordZ: 49.9,
    distance: 1527464,
    heading: 40,
    pitch: 36,
    duration: 1,
    fly: true
  },
  TGAL: {
    coordType: 0,
    coordTypeZ: 0,
    limitPitch: [5, 89],
    limitYaw: [0, 359],
    limitDistance: [1077744, 2177744],
    limitCoordZ: [10, 300], // 端渲染暂不支持此属性
    center: [18.38314508463, 26.95064707559], // 端渲染暂不支持此属性
    radius: 2000000 // 端渲染暂不支持此属性
  },
  VesselsInPort: {
    centerCoord: [640.9321484375, -78.45014648437],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:-0.28,
    distance: 208,
    heading: 2,
    pitch: 30,
    duration: 1,
    fly: true
  },
  "GK-GangKou":{
    coordType: 0,
    coordTypeZ: 0,
    limitPitch: [5, 89],
    limitYaw: [0, 359],
    limitDistance: [0, 3000],
    limitCoordZ: [0, 300], // 端渲染暂不支持此属性
    center: [0, 0], // 端渲染暂不支持此属性
    radius: 2000000 // 端渲染暂不支持此属性
  },
  "GK-GangKou_default":{
    centerCoord: [-215.374765625, -65.01751953125],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:49.9,
    distance: 272,
    heading: 133,
    pitch: 27,
    duration: 1,
    fly: true
  },
  CraneEquipment:{
    centerCoord: [-34.61683837891, -86.11943359375],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:49.9,
    distance: 43,
    heading: 133,
    pitch: 27,
    duration: 1,
    fly: true
  },
  GantryCrane:{
    centerCoord: [-130.58151367188, -219.42888671875],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:49.9,
    distance: 0,
    heading: 159,
    pitch: 19,
    duration: 1,
    fly: true
  },
  maritimeSafety:{
    centerCoord: [-43.39571289062, -73.02748535156],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:49.9,
    distance: 21,
    heading: 124,
    pitch: 28,
    duration: 1,
    fly: true
  },
  EmergencyCommand:{
    centerCoord: [69.16093261719, 33.25790771484],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:49.9,
    distance: 23,
    heading: 303,
    pitch: 44,
    duration: 1,
    fly: true
  },
  BridgeCrane:{
    centerCoord: [-131.49690429688, -80.59130371094],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:49.9,
    distance: 0,
    heading: 161,
    pitch: 14,
    duration: 1,
    fly: true
  },
  GantryCrane:{
    centerCoord: [-1.57592971802, 38.78372070312],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:49.9,
    distance: 31,
    heading: 178,
    pitch: 17,
    duration: 1,
    fly: true
  },
  yardManagement:{
    centerCoord: [-184.15841796875, -382.99171875],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:49.9,
    distance: 0,
    heading: 128,
    pitch: 15,
    duration: 1,
    fly: true
  },
  JointResponse:{
    centerCoord: [92.626796875, -55.5018359375],
    coordType: 0,
    coordTypeZ: 0,
    coordZ:49.9,
    distance: 327,
    heading: 49,
    pitch: 28,
    duration: 1,
    fly: true
  },
  //#endregion

  //#region 视野限制参数
  ShenZhenWan: {
    center: [113.943382, 22.518723],
    coordType: 0,
    coordTypeZ: 0,
    limitYaw: [0, 359],
    limitPitch: [15, 80],
    limitCoordZ: [-10, 15000],
    limitDistance: [0, 160000],
    radius: 10000000
  },
  ShenZhenL0: {
    center: [114.190071, 22.635887],
    coordType: 0,
    coordTypeZ: 0,
    limitYaw: [0, 359],
    limitPitch: [15, 80],
    limitCoordZ: [-10, 15000],
    limitDistance: [0, 160000],
    radius: 10000000
  }
  //#endregion
};
